function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'ice-grey': 'rgb(199, 199, 199)','grey': 'rgb(152, 152, 152)','midnight': 'rgb(7, 7, 7)','navy-blue': 'rgb(3, 11, 113)','black': 'rgb(17, 17, 17)','blue': 'rgb(0, 116, 217)','light-blue': 'rgb(200, 240, 255)','aqua': 'rgb(127, 219, 255)','teal': 'rgb(57, 204, 204)','olive': 'rgb(128, 128, 0)','green': 'rgb(46, 204, 64)','lime': 'rgb(1, 255, 112)','yellow': 'rgb(255, 220, 0)','orange': 'rgb(255, 133, 27)','red': 'rgb(255, 65, 54)','fuchsia': 'rgb(240, 18, 190)','purple': 'rgb(177, 13, 201)','maroon': 'rgb(133, 20, 75)','silver': 'rgb(221, 221, 221)','pink': 'rgb(250, 190, 190)','brown': 'rgb(154, 99, 36)','mint': 'rgb(170, 255, 195)','lavender': 'rgb(230, 190, 255)','tan': 'rgb(160, 78, 59)','cognac': 'rgb(161, 87, 50)','indigo': 'rgb(45, 46, 51)','military': 'rgb(118, 105, 82)','charcoal': 'rgb(101, 97, 104)','french': 'rgb(103, 109, 141)','black-and-grey': 'rgb(152, 152, 152)','black-mitt-black-10x': 'rgb(17, 17, 17)','blue-mitt-black-pad': 'rgb(0, 116, 217)','black-mitt-black-pad': 'rgb(17, 17, 17)','mixed-earth-tone-colors': 'rgb(195, 119, 0)','cool-grey': 'rgb(199, 199, 199)','soft': 'rgb(0, 0, 0)','black-blue': 'rgb(25, 185, 199)','black-pink': 'rgb(255, 42, 162)','grey-blue': 'rgb(199, 199, 199)','underglow': 'rgb(252, 27, 154)','ectoplasm': 'rgb(187, 253, 92)','octane-ectoplasm': 'rgb(187, 253, 92)','octane-underglow': 'rgb(252, 27, 154)','octane-riptide': 'rgb(37, 197, 206)','solar-flare': 'rgb(255, 177, 28)','riptide': 'rgb(7, 235, 248)','black-ice': 'rgb(255, 255, 255)','perfect-purple': 'rgb(94, 30, 178)','pine': 'rgb(87, 100, 70)','sand': 'rgb(215, 207, 187)','ice-grey-and-grey': 'rgb(152, 152, 152)','red-white-blue': 'rgb(44, 30, 111)','black-ice': 'rgb(48, 48, 50)','octane-livewire': 'rgb(227, 232, 78)','octane-avalanche': 'rgb(88, 68, 217)','livewire': 'rgb(227, 232, 78)','avalanche': 'rgb(88, 68, 217)','digital-camo': 'rgb(54, 62, 48)','trc-blue': 'rgb(155, 203, 241)',};

    this.images = {'ice-grey-and-grey': 'url("//theragcompany.com/cdn/shop/files/ice-grey-and-grey_68x.png?v=42601")','aqua-grey': 'url("//theragcompany.com/cdn/shop/files/aqua-and-grey_68x.png?v=42601")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
